import { Button, Offcanvas } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import React, { useState } from 'react';
import { List } from 'react-bootstrap-icons';

export const NonAuthNaviMenu = () => {
    const { instance } = useMsal();
    const [show, setShow] = useState(false);
    const [isButtonVisible, setButtonVisible] = useState(true);

    const handleClose = () => {
        setShow(false);
        setButtonVisible(true);
    };

    const handleShow = () => {
        setShow(true);
        setButtonVisible(false);
    }

    let activeAccount;

    if (instance) {
        activeAccount = instance.getActiveAccount();
        console.log(activeAccount);
    }

    const handleLoginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement='end' scroll="true">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title as="h2">
                        ALIVE Platform Menu
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="drawerNav">
                        <ul className="drawerNav__list list-group list-group-flush">
                            <li className="drawerNav__item list-group-item">
                                <a href="https://alive0309.org" className='drawerNav__link' rel="noopener">
                                    ALIVE Homepage
                                </a>
                            </li>
                            <li className="drawerNav__item list-group-item">
                                <a href="https://alive0309.org/alive-platform/" className='drawerNav__link' rel="noopener">
                                    ALIVE Platform
                                </a>
                            </li>

                            <li className="drawerNav__item list-group-item">
                                <Button className='drawerNav__link p-0' variant="link" onClick={handleLoginRedirect}>
                                    サインイン
                                </Button>
                            </li>
                        </ul>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {isButtonVisible && (
                <div className="position-fixed top-0 end-0 p-0" style={{zIndex: 1050}}>
                    <Button class="btn p-0" variant="light" onClick={handleShow} style={{ zIndex: 9999, position: 'relative', backgroundColor: 'transparent' }}>
                        <List size={38} />
                    </Button>
                </div>
            )}
        </>
    );
};
